import map from "lodash/fp/map";
import constants from "../../core/constants";
import moment from "moment";
class CorporateTransportationSubmissionsPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Corporate Transportations",
      state: "corporatetransportationsubmissions",
      name: "corporatetransportationsubmissions",
    };
    this.fields = [
      { title: "Corporate Name", name: "corporate_name" },
      { title: "Phone Number", name: "phone_number" },
      { title: "Corporate Industry", name: "industry" },
      { title: "No. of Employees", name: "number_of_employees" },
      { title: "Contact Name", name: "contact_name" },
      { title: "Contact Email", name: "email" },
      { title: "Corporate Has Transportation", name: "has_transportation" },
      { title: "City", name: "city" },
      { title: "Created At", name: "createdAt" },
      { title: "Updated At", name: "updatedAt" },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.has_transportation = item.has_transportation ? "Yes" : "No";
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);
      item.updatedAt = moment(item.updatedAt).format(constants.dateTimeFormat);

      return item;
    };

    return map(format)(data);
  }
}

export default CorporateTransportationSubmissionsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/corporateTransportationSubmissions/corporateTransportationSubmissions.transforms.js